import { dataHooks } from '@wix/data-hooks';

export const appDataHooks = dataHooks<{
  subHeader;
  widgetContainer;
}>('app');
